import { ArticleParagraph1, InformationTooltip } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16, IconFunctionalWarningSign16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { EInformerLevel } from 'shared/types/rosreestr';

import * as styles from './RosreestrItemTooltip.css';

interface ITooltipProps {
  title: string;
  description: string[];
  informerLevel?: EInformerLevel | null;
}

export function RosreestrItemTooltip({ title, description, informerLevel }: ITooltipProps) {
  const [open, setOpen] = React.useState(false);

  const IconComponent = React.useMemo(
    () => (informerLevel === EInformerLevel.Warning ? IconFunctionalWarningSign16 : IconFunctionalInformationCircle16),
    [informerLevel],
  );

  const iconColor = React.useMemo(
    () => (informerLevel === EInformerLevel.Warning ? 'accent-warning-primary' : 'accent-main-primary'),
    [informerLevel],
  );

  const openModal = React.useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = React.useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <InformationTooltip
      open={open}
      header={title}
      content={
        <>
          {description.map((text, index) => (
            <div className={styles['item']} key={index}>
              <ArticleParagraph1>{text}</ArticleParagraph1>
            </div>
          ))}
        </>
      }
      onClose={closeModal}
    >
      <button type="button" className={styles['button']} onClick={openModal}>
        <IconComponent color={iconColor} />
      </button>
    </InformationTooltip>
  );
}
